// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + {"284":"413b83843c409412b45a0c2692fc674f","760":"808bdd5068305ed47fcee9bf1fdc6233"}[chunkId] + ".js";
};